<template>
  <div class="productList">
    <breadcrumb></breadcrumb>
    <!--子导航-->
    <!-- <div class="page-width">
      <div class="sonNav">
        <swiper class="hidden-md-and-up" :options="recommendedSwiper" ref="mySwiper">
          <swiper-slide v-for="(item,index) in sonNavList" data-index="index" :key="index">
            <a :href="item.id" style="max-width: 136px">{{item.name}}</a>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev el-icon-caret-left hidden-md-and-up"></div>
        <div class="swiper-button-next el-icon-caret-right hidden-md-and-up"></div>
        <ul class="hidden-md-and-down">
          <li v-for="(item,index) in sonNavList" data-index="index" :key="index" @click="fetchSelectedCategories(item.ProductCategory_id)">
            <a >{{item.Name}}</a>
          </li>
        </ul>
      </div>
    </div> -->
    <!--end子导航-->

    <!--start search form-->
        <div class="search-box">
            <input type="text" v-bind:placeholder="$t('productNameOrNumber')"  v-model="searchTerm" v-on:keyup.enter="searchProduct">
            <button @click="searchProduct" >{{ $t('submit') }}</button>
        </div>
    <!--end search form-->


    <!--列表主题-->
    <div class="product-listing-container search-product-list-container">
        <ul>
          <li v-for="(item,index) in list" data-index="index" :key="index">
            <productCard v-if='$i18n.locale=="en"'
              v-bind:img="item.Thumbnail"
              v-bind:link="item.link"
              v-bind:name="item.Name"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
              v-bind:endTime="item.EndTime"
              v-bind:GroupedSaleLimit="item.GroupedSaleLimit"
              v-bind:GroupSoldQuantity="item.GroupSoldQuantity"
            ></productCard>
            <productCard v-if='$i18n.locale=="ch"'
              v-bind:img="item.Thumbnail"
              v-bind:link="item.link"
              v-bind:name="item.Description"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
              v-bind:endTime="item.EndTime"
              v-bind:GroupedSaleLimit="item.GroupedSaleLimit"
              v-bind:GroupSoldQuantity="item.GroupSoldQuantity"
            ></productCard>
          </li>
        </ul>
        <!-- <div class="loadmore disableBtn" v-show="list.length === 0">
          <span>No Results</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div> -->
      </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import productCard from './productCard';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";

export default {
  name: "search",
  components: {
    breadcrumb,
    productCard,
  },
  props: {
    group: {
      type: String,
    }
  },
  data() {
    return {
      collection:"",
      searchTerm: "",
      options: [{
        value: '选项1',
        label: 'Featured Items'
      }, {
        value: '选项2',
        label: 'Best Selling'
      }, {
        value: '选项3',
        label: 'Alphabetically, A-Z'
      }, {
        value: '选项4',
        label: 'Alphabetically, Z-A'
      }, {
        value: '选项5',
        label: 'Price, low to high'
      }],
      recommendedSwiper: {
        slidesPerView: 5,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        roundLengths : true,
        spaceBetween: 20,
        breakpoints: {
          320: {
            slidesPerView: 1,
          },
          //width >= 480
          480:{
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 4,
          },
          //width >= 640
          990: {
            slidesPerView: 4,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      list: []
    }
  },
  methods: {
    ...mapActions('search',['fetchProducts']),
    ...mapMutations('products', ['updateActiveProduct']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    searchProduct() {
      this.$router.push({ path: 'search', query: { product: this.searchTerm }})
    },
    fetchProductWithSearchTerm(product) {
      this.fetchProducts(product)
      .then(res => {
        let ctemp1 = [];
        let ctemp2 = [];
        let catOut = [];
        let catReg = [];
        res.data.Products.map((a)=>{
        if (this.isOutOfStock(a)) {
          ctemp2.push(a)
        } else {
          ctemp1.push(a)
        }
         })
        catOut = ctemp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        catReg = ctemp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })
        this.list = catReg.concat(catOut);
        this.searchTerm = '';
      })
      .catch(err => {
        console.log('err fetching product', err)
      })
    },
    addToCart: function(item) {
      item.quantity = this.num;
      if (isUserAuthenticated()) {
        item.quantity = this.num;
        this.$store.dispatch('cart/addCart', item);
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
  },
  computed: mapState({
    search: state => state.navbar.search,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0]
  }),
  watch: {
    search: function(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.searchTerm = newVal;
        this.searchProduct();
      }
    },
    '$route.query': {
      immediate: true,
      handler(newVal) {
        console.log(newVal)
        if(newVal.product==''){
          return
        }
        this.fetchProductWithSearchTerm(newVal.product);
      }
    }
  },
  mounted: function() {
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productList.less";
@import "../assets/css/search.less";
</style>



// WEBPACK FOOTER //
// src/view/search.vue